import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import renderField from "../../components/FormInputs/renderField";

class LoginForm extends Component {
  render() {
    const { submitting, handleSubmit, loginError, loginSuccess } = this.props;

    let cardClass = "login-card";
    if (loginError) cardClass = "login-card login-card--shake";
    else if (loginSuccess) cardClass = "login-card login-card--success";

    return (
      <div
        className={cardClass}
        style={{
          background: "#FFFFFF",
          borderRadius: "20px",
          boxShadow:
            "0 40px 100px rgba(0,0,0,0.6), 0 16px 40px rgba(0,0,0,0.35), 0 4px 12px rgba(0,0,0,0.2)",
          overflow: "hidden",
        }}
      >
        {/* Animated shimmer bar at top */}
        <div
          style={{
            height: "5px",
            background:
              "linear-gradient(90deg, #FFE600, #F5D000, #FFE600, #F5D000)",
            backgroundSize: "200% 100%",
            animation: "shimmer 3s linear infinite",
          }}
        />

        {/* Card header — white, high contrast */}
        <div
          style={{
            padding: "32px 36px 22px",
            borderBottom: "1px solid #F1F5F9",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "14px",
            }}
          >
            <div
              style={{
                background: "linear-gradient(180deg, #FFE600, #F0C000)",
                width: "5px",
                height: "42px",
                borderRadius: "3px",
                marginRight: "14px",
                flexShrink: 0,
              }}
            />
            <div>
              <div
                style={{
                  color: "#0B1437",
                  fontSize: "10px",
                  fontWeight: "900",
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  marginBottom: "4px",
                }}
              >
                EY
              </div>
            </div>
          </div>
          <div
            style={{
              height: "1px",
              background: "linear-gradient(90deg, #E2E8F0, #CBD5E1, #E2E8F0)",
            }}
          />
          <p
            style={{
              color: "#64748B",
              fontSize: "14px",
              marginTop: "14px",
              marginBottom: 0,
            }}
          >
            Sign in to your account to continue
          </p>
        </div>

        {/* Form body */}
        <div style={{ padding: "8px 36px 36px" }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group" style={{ marginBottom: "18px" }}>
              <label
                style={{
                  display: "block",
                  color: "#374151",
                  fontSize: "11px",
                  fontWeight: "700",
                  textTransform: "uppercase",
                  letterSpacing: "0.07em",
                  marginBottom: "7px",
                }}
              >
                Username
              </label>
              <Field name="text" type="text" component={renderField} />
            </div>

            <div className="form-group" style={{ marginBottom: "28px" }}>
              <label
                style={{
                  display: "block",
                  color: "#374151",
                  fontSize: "11px",
                  fontWeight: "700",
                  textTransform: "uppercase",
                  letterSpacing: "0.07em",
                  marginBottom: "7px",
                }}
              >
                Password
              </label>
              <Field name="password" type="password" component={renderField} />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="login-submit-btn"
              style={{
                width: "100%",
                height: "48px",
                background: submitting
                  ? "#E5E7EB"
                  : "linear-gradient(135deg, #FFE600 0%, #F5D000 100%)",
                border: "none",
                borderRadius: "100px",
                color: submitting ? "#9CA3AF" : "#0B1437",
                fontSize: "15px",
                fontWeight: "700",
                letterSpacing: "0.03em",
                cursor: submitting ? "not-allowed" : "pointer",
                transition: "all 0.2s cubic-bezier(0.22, 1, 0.36, 1)",
                boxShadow: submitting
                  ? "none"
                  : "0 6px 20px rgba(255,230,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              {submitting && (
                <span
                  style={{
                    width: "14px",
                    height: "14px",
                    border: "2px solid #9CA3AF",
                    borderTopColor: "transparent",
                    borderRadius: "50%",
                    display: "inline-block",
                    animation: "spin 0.7s linear infinite",
                  }}
                />
              )}
              {submitting ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <p
            style={{
              textAlign: "center",
              color: "#94A3B8",
              fontSize: "12px",
              marginTop: "22px",
              marginBottom: 0,
            }}
          >
            &copy; {new Date().getFullYear()} EY. All rights reserved.
          </p>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "stackedForm",
})(LoginForm);



// WEBPACK FOOTER //
// src/pages/Login/LoginForm.js